module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-locked-77a59e9e2c4f4786478cf95446cc652b.svg";